import React from 'react'
import {
    Autocomplete,
    Dialog,
    DialogContent,
    DialogTitle,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material'
import {
    FilterRow,
    StyledTextField,
    DateInput,
    DarkButton,
    StyledTable,
    StyledHeaderCell,
    StyledBodyCell,
    StyledBodyRow,
    EmptyState,
} from '../../../ui/StyledComponents'
import { formatDate, transportLabel } from '../../../helpers/logisticaHelper'
import { renderTransportOption } from './transportOption'

const sheetStatusLabels = { Active: 'Activa', Cancelled: 'Anulada' }

export default function BuscarPlanillaDialog({
    open,
    onClose,
    filtro,
    onFiltroChange,
    transports,
    onFiltrar,
    resultados,
    onSelectPlanilla,
}) {
    const transportSeleccionado =
        transports.find((t) => t.code === filtro.transportCode) || null

    // La planilla trae solo el código: la descripción sale de la lista, si el transporte sigue activo
    const transportDisplay = (code) => {
        const description = transports.find((t) => t.code === code)?.description
        return description ? `${code} - ${description}` : code
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>Búsqueda de planillas de reparto</DialogTitle>
            <DialogContent>
                <FilterRow sx={{ mb: 2, pt: 1 }}>
                    <DateInput
                        label="Fecha de reparto desde"
                        value={filtro.fechaDesde}
                        onChange={(value) => onFiltroChange('fechaDesde', value)}
                        size="small"
                    />
                    <DateInput
                        label="Fecha de reparto hasta"
                        value={filtro.fechaHasta}
                        onChange={(value) => onFiltroChange('fechaHasta', value)}
                        size="small"
                    />
                    <Autocomplete
                        size="small"
                        options={transports}
                        value={transportSeleccionado}
                        getOptionLabel={transportLabel}
                        isOptionEqualToValue={(a, b) => a.code === b.code}
                        renderOption={renderTransportOption}
                        onChange={(_, value) => onFiltroChange('transportCode', value?.code ?? '')}
                        sx={{ flex: 1.4 }}
                        renderInput={(params) => <StyledTextField {...params} label="Transporte" />}
                    />
                    <StyledTextField
                        size="small"
                        label="N° Documento"
                        value={filtro.documentNumber}
                        onChange={(e) => onFiltroChange('documentNumber', e.target.value)}
                        sx={{ flex: 1 }}
                    />
                    <DarkButton onClick={onFiltrar} disabled={!filtro.fechaDesde || !filtro.fechaHasta} sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
                        Filtrar
                    </DarkButton>
                </FilterRow>

                <TableContainer sx={{ maxHeight: { xs: 360, sm: 480, md: '58vh' }, overflow: 'auto' }}>
                    <StyledTable size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <StyledHeaderCell align="center">Planilla</StyledHeaderCell>
                                <StyledHeaderCell align="center">Fecha de reparto</StyledHeaderCell>
                                <StyledHeaderCell align="center">Fecha de carga</StyledHeaderCell>
                                <StyledHeaderCell align="center">Transporte</StyledHeaderCell>
                                <StyledHeaderCell align="center">Patente</StyledHeaderCell>
                                <StyledHeaderCell align="center">Estado</StyledHeaderCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {resultados.length > 0 ? (
                                resultados.map((planilla) => (
                                    <StyledBodyRow
                                        key={planilla.sheetId}
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => onSelectPlanilla(planilla)}
                                    >
                                        <StyledBodyCell align="center">{planilla.sheetId}</StyledBodyCell>
                                        <StyledBodyCell align="center">{formatDate(planilla.deliveryDate)}</StyledBodyCell>
                                        <StyledBodyCell align="center">{formatDate(planilla.loadDate)}</StyledBodyCell>
                                        <StyledBodyCell align="center">{transportDisplay(planilla.transportCode)}</StyledBodyCell>
                                        <StyledBodyCell align="center">{planilla.plate}</StyledBodyCell>
                                        <StyledBodyCell align="center">{sheetStatusLabels[planilla.status] ?? planilla.status}</StyledBodyCell>
                                    </StyledBodyRow>
                                ))
                            ) : (
                                <TableRow>
                                    <StyledBodyCell colSpan={6}>
                                        <EmptyState>Filtrá por fecha de reparto para ver las planillas guardadas.</EmptyState>
                                    </StyledBodyCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </StyledTable>
                </TableContainer>
            </DialogContent>
        </Dialog>
    )
}
